import {
    Pagination,
    PaginationContent,
    PaginationEllipsis,
    PaginationFirst,
    PaginationItem,
    PaginationLast,
    PaginationLink,
    PaginationNext,
    PaginationPrevious,
} from '@/components/ui/pagination'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'

const TablePagination = ({ table }) => {
    const currentPage = table.getState().pagination.pageIndex
    const totalPages = table.getPageCount()
    const pageSize = table.getState().pagination.pageSize

    // Generate page numbers to show
    const getVisiblePages = () => {
        const delta = 2
        const range = []
        const rangeWithDots = []

        for (let i = Math.max(0, currentPage - delta); i <= Math.min(totalPages - 1, currentPage + delta); i++) {
            range.push(i)
        }

        if (range[0] > 1) {
            rangeWithDots.push(0)
            if (range[0] > 2) rangeWithDots.push('...')
        }

        rangeWithDots.push(...range)

        if (range[range.length - 1] < totalPages - 2) {
            if (range[range.length - 1] < totalPages - 3) {
                rangeWithDots.push('...')
            }
            rangeWithDots.push(totalPages - 1)
        }

        return rangeWithDots
    }

    const visiblePages = getVisiblePages()

    return (
        <div className="tw:flex tw:flex-row-reverse tw:items-center tw:pt-2 tw:px-3">
            {/* Always show page size selector */}
            <div className="tw:flex tw:items-center tw:gap-2">
                <Select
                    value={pageSize.toString()}
                    className="tw:!text:sm"
                    onValueChange={(value) => {
                        table.setPageSize(Number(value))
                    }}
                >
                    <SelectTrigger className="tw:min:w-16 tw:w-fit tw:!max-h-8">
                        <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="5">5</SelectItem>
                        <SelectItem value="10">10</SelectItem>
                        <SelectItem value="25">25</SelectItem>
                        <SelectItem value="50">50</SelectItem>
                        <SelectItem value="100">100</SelectItem>
                    </SelectContent>
                </Select>
                <span className="tw:text-sm tw:text-gray-200">per page</span>
            </div>

            <div>
                {/* Only show pagination controls when there are multiple pages */}
                {totalPages > 1 && (
                    <Pagination>
                        <PaginationContent className="tw:!mb-0">
                            <PaginationItem>
                                <PaginationFirst
                                    onClick={() => table.setPageIndex(0)}
                                    showText={false}
                                    className={
                                        !table.getCanPreviousPage()
                                            ? 'tw:pointer-events-none tw:opacity-50'
                                            : 'tw:cursor-pointer'
                                    }
                                />
                            </PaginationItem>

                            <PaginationItem>
                                <PaginationPrevious
                                    onClick={() => table.previousPage()}
                                    showText={false}
                                    className={
                                        !table.getCanPreviousPage()
                                            ? 'tw:pointer-events-none tw:opacity-50'
                                            : 'tw:cursor-pointer'
                                    }
                                />
                            </PaginationItem>

                            {visiblePages.map((page, index) => (
                                <PaginationItem key={index}>
                                    {page === '...' ? (
                                        <PaginationEllipsis />
                                    ) : (
                                        <PaginationLink
                                            onClick={() => table.setPageIndex(page)}
                                            isActive={page === currentPage}
                                            className="tw:cursor-pointer"
                                        >
                                            {page + 1}
                                        </PaginationLink>
                                    )}
                                </PaginationItem>
                            ))}

                            <PaginationItem>
                                <PaginationNext
                                    onClick={() => table.nextPage()}
                                    showText={false}
                                    className={
                                        !table.getCanNextPage()
                                            ? 'tw:pointer-events-none tw:opacity-50'
                                            : 'tw:cursor-pointer'
                                    }
                                />
                            </PaginationItem>

                            <PaginationItem>
                                <PaginationLast
                                    onClick={() => table.setPageIndex(totalPages - 1)}
                                    showText={false}
                                    className={
                                        !table.getCanNextPage()
                                            ? 'tw:pointer-events-none tw:opacity-50'
                                            : 'tw:cursor-pointer'
                                    }
                                />
                            </PaginationItem>
                        </PaginationContent>
                    </Pagination>
                )}
            </div>
        </div>
    )
}

export default TablePagination
